import RichTextToolbar from './RichTextToolbar.component';

export default RichTextToolbar;